import React from "react";
//#region Redux
import { ThunkDispatch } from "redux-thunk";
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { StyleEnums } from "models/enums";
import { TodoConstants } from "utils/constants";
import { DeadlineConsequencesCardProps } from "models/propTypes/todoPropTypes";
import { WintSuperkollAPIModelDeadlines, WintUtilsWebApi } from "wint-api-client/dist/types";
import { AxiosResponse } from "axios";
//#endregion
//#region components
import { EntityNavigationCard, EntityNavigationCardContainer, EntityNavigationCardContent } from "components/common";
import { useConsequencePreviewDialog } from "components/deadline";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { Grid } from "@mui/material";
import cssExports from "theme/styles/main.module.scss";

const DeadlineConsequencesCard: React.FC<DeadlineConsequencesCardProps> = (props) => {
  const { consequences } = props;

  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const previewDialog = useConsequencePreviewDialog(consequences);

  const filterFunc = React.useCallback(async () => {
    return {
      data: {
        items: consequences,
        totalItems: consequences.length,
        totalItemsWithOutFilter: consequences.length,
        page: 0,
        numPerPage: consequences.length,
      },
    } as AxiosResponse<WintUtilsWebApi.ListResponse<WintSuperkollAPIModelDeadlines.DeadlineConsequence>>;
  }, [consequences]);

  const onPreviewClick = async () => {
    dispatch(displayDialog(previewDialog()));
  };

  const render = (
    total: number,
    numPerPage: number,
    onCurrentIndexUpdate: (index: number, pageNumber: number) => void,
    markAsDone: (id: number) => void,
    currentItem: WintSuperkollAPIModelDeadlines.DeadlineConsequence
  ) => (
    <EntityNavigationCard
      total={total}
      displayType={StyleEnums.DisplayType.Info}
      headerText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Consequences)}
      onCurrentIndexUpdate={onCurrentIndexUpdate}
      navigationText={""}
    >
      <EntityNavigationCardContent
        title={currentItem?.title ?? ""}
        description={currentItem?.description ?? ""}
        footerText={
          <Grid container>
            {currentItem?.associatedCosts?.map((cost, index) => (
              <Grid key={index} item xs>
                {cost.amountWithUnit ? <Grid container>{cost.amountWithUnit}</Grid> : <></>}
                {cost.description ? (
                  <Grid container className={cssExports.consequenceAmountDescription}>
                    {cost.description}
                  </Grid>
                ) : (
                  <></>
                )}
              </Grid>
            ))}
          </Grid>
        }
        showButton
        buttonText={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ReadMore)}
        onClick={onPreviewClick}
        displayType={StyleEnums.DisplayType.None}
      />
    </EntityNavigationCard>
  );

  return (
    <EntityNavigationCardContainer
      render={render}
      filter={filterFunc}
      numPerPage={TodoConstants.TodosPerPage}
    ></EntityNavigationCardContainer>
  );
};
export default DeadlineConsequencesCard;
